// extracted by mini-css-extract-plugin
export default {"root":"ErrorMessage_root__1q6Sd"};